/**
 * @description
 * Navigation component for MarketplaceConfig page
 *
 * @author AI Developer <ai@byteable.ai>
 * @date 2025-01-10
 */

import { MarketplaceConfigNavigationProps } from './types';

/**
 * Marketplace configuration navigation sidebar component
 */
export function MarketplaceConfigNavigation({
  activeSection,
  onSectionChange,
}: MarketplaceConfigNavigationProps) {
  const sections = [
    { key: 'system', label: 'System Configuration' },
    { key: 'deployment', label: 'Deployment Settings' },
    { key: 'security', label: 'Security Settings' },
    { key: 'analytics', label: 'Analytics Settings' },
    { key: 'github', label: 'GitHub Configuration' },
    { key: 'cloudflare', label: 'Cloudflare Settings' },
    { key: 'test', label: 'Test Deployment' },
  ] as const;

  return (
    <nav className="space-y-1">
      {sections.map((section) => (
        <button
          key={section.key}
          onClick={() => onSectionChange(section.key as any)}
          className={`w-full rounded-md px-3 py-2 text-left text-sm font-medium transition-colors ${
            activeSection === section.key
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
          }`}
        >
          {section.label}
        </button>
      ))}
    </nav>
  );
}
